export const EmergencyMessageType = {
    STANDARD: 1,
    CUSTOM: 2,
};

export const EmergencyMessageSeverity = {
    CRITICAL: 'critical',
    SEVERE: 'severe',
    URGENT: 'urgent',
    CUSTOM: 'custom',
};

export const EmergencyCallProfileType = {
    CUSTOM_USER_LIST: 1,
    ACTIVE_SELECTED_CHANNEL: 2,
};

export const EmergencyStatus = {
    CLOSED: 'closed',
    PENDING: 'pending',
    ACTIVE: 'active',
};
